if(typeof BSS_B2B && window.location.pathname !== '/cart') {
  let flag = true;
  let flagQuickView = true;
  try {
    setTimeout(() => {
      const targetNode = document.querySelector('#ajax-cart__content');
      const observer = new MutationObserver((mutationsList, observer) => {
          for (let index = 0; index < mutationsList.length; ++index ) {
              if (index === mutationsList.length - 1) {
                  if(flag) {
                    BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html(), false, false))
                  }
                  flag = !flag;
              }
          }
      });
      
    const observerConfig = { childList: true, subtree: true };
    observer.observe(targetNode, observerConfig);
    
      // Quickview
      const target = document.querySelector("#quickshop");
      const observerQuickView = new MutationObserver((mutationsList, observer) => {
        for (let index = 0; index <  mutationsList.length; ++index) {
          if(index === mutationsList.length-1 && mutationsList[index].target.classList.contains("price-ui")) {
                 $(".price-ui .price").removeAttr("bss-b2b-product-active");
                $(".price-ui .price .money").removeAttr("bss-b2b-product-active");
                $(".price-ui .price .money").attr("bss-b2b-product-id", $(".product-gallery__image.is-selected").attr("data-product-id"));
                BSS_B2B.cp.changeProductPrice(JSON.parse($("#bss-b2b-store-data").html()), ".price-ui .price .money", false)
             
          }
        }
      });
      
      observerQuickView.observe(target, observerConfig);
    }, 2000)
    
  } catch(e) {
    console.error(e);
  }
}

function mutationAjaxCart(){
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList.contains('ajax-cart__form')) {
        BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html(), false, false));
         $("#checkout, button[name='checkout']").css({'pointer-events': 'none', 'opacity': '0.6'})
      }
    });
  });
  const targetNode = document.querySelector('.ajax-cart__form');
  const config = { attributes: true, childList: true, subtree: true };
  targetNode && observer.observe(targetNode, config);
}
let loop = setInterval(() => {
  const targetNode = document.querySelector('.ajax-cart__form');
  if(targetNode) {
    mutationAjaxCart();
    clearInterval(loop);
  }
}, 100)

document.addEventListener("bss_b2b_cart_fixer_done", () => {
  $("#checkout, button[name='checkout']").css({'pointer-events': 'unset', 'opacity': '1'})
});

setTimeout(() => {
   $("#checkout, button[name='checkout']").css({'pointer-events': 'unset', 'opacity': '1'})
}, 15000)
